import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { UserSquare } from 'components/icons'

type Props = IconProps

const PublicAgent: FC<Props> = (props) => {
  return <UserSquare {...props} />
}

const PublicAgentExports = {
  PublicAgent,
}

export default PublicAgentExports
